import React from 'react';
import {Props} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {ResponsiveView} from '../../../../../shared/components/responsiveView';
import {DeviceSize, useDeviceSize} from '../../../../../shared/theme/helpers';
import {ImageStyle, Platform, View} from 'react-native';
import {images} from '../../../../../assets/icons';
import {useTheme} from '../../../../../shared/theme';
import {hexToRgbA} from '../../../../../shared/pipes/color';
import {InputFormModal} from '../linkedAccounts/inputForm/InputFormModal';
import {useModal} from '../../../../../shared/components/modal';
import {ApplicationsMenu} from '../applications/applicationsMenu/ApplicationsMenu';

export default ({
  children,
  icon,
  hideImage = false,
  backgroundStyle = {},
  iconStyle,
  contentStyle,
  containerStyle,
  btnTitle: _btnTitle,
  btnType,
  cardRegInit,
}: Props) => {
  const {color} = useTheme();
  const ds = useDeviceSize();
  const modals = useModal();
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContent: {
      position: 'relative',
      zIndex: 1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          maxWidth: '60%',
          width: 760,
          minHeight: 576,
        },
        {
          maxWidth: '100%',
          width: '100%',
        },
      ),
    },
    sectionContainer: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    sectionContainerBg: {
      position: 'absolute',
      zIndex: -1,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          top: -15,
          width: 560,
          height: 576,
          right: 5,
        },
        {
          width: 234,
          height: 377,
          right: -24,
          bottom: 0,
        },
      ),
    },
    sectionContainerBgImage: {
      marginLeft: 'auto',
      marginBottom: 'auto',
      alignSelf: 'flex-start',
      color: theme.color.shaddowBg,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          resizeMode: 'center',
          width: 560,
          height: 576,
        },
        {
          width: 234,
          height: 377,
          resizeMode: 'contain',
        },
      ),
    } as ImageStyle,
    sectionIcon: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingRight: 35,
      position: 'relative',
      zIndex: 0,
    },
  }));
  const Pattern = ds === DeviceSize.desktop ? images.ServiceDetailsPattern : images.ServiceDetailsPatternMobile;

  const _handlePressBtn = () => {
    modals.show({
      render(modal, methods) {
        const onClose = () => {
          methods.remove(modal.id);
        };
        if (btnType === 'linkedAccountInput') return <InputFormModal onClose={onClose} />;
        if (btnType === 'applicationsMenu') return <ApplicationsMenu cardRegInit={cardRegInit} onClose={onClose} />;
      },
    });
  };

  return (
    <View style={[styles.sectionContainer, containerStyle]}>
      <View style={[styles.sectionContent, contentStyle]}>{children}</View>
      <View style={{display: 'flex', flexDirection: 'column'}}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <View style={[styles.sectionIcon, iconStyle]}>{icon}</View>
        </ResponsiveView>
        {/* <View>
          <Button
            id='SubCardBtn'
            style={{width: 316, alignSelf: 'flex-start', marginLeft: 63}}
            type='secondary'
            onPress={handlePressBtn}
            text={btnTitle}
          />
        </View> */}
      </View>
      {!hideImage ? (
        <View style={[styles.sectionContainerBg, backgroundStyle]}>
          <Pattern
            {...styles.sectionContainerBgImage}
            color={Platform.OS === 'web' ? hexToRgbA(color.shaddowBg, 0.15) : color.patternBgColor}
            width={styles.sectionContainerBgImage.width as number}
            height={styles.sectionContainerBgImage.height as number}
            hideForVisuallyImpaired
          />
        </View>
      ) : null}
    </View>
  );
};
